function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKtxEumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "900.029mm",
    height: "147.987mm",
    viewBox: "0 0 900.029 147.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M289.652 25.72H122.266L64.968 64.974l6.32-8.573 9.022-30.68H36.543L0 147.987h43.244l14.504-45.566 5.863-4.06 19.405 49.626h43.763l-26.617-72.26L135.8 51.89l36.095.454-27.52 95.643h43.76l27.525-95.192h41.505l43.313 95.192h43.76l-36.994-83.465-20.525 5.482 14.21-18.564z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.14388
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.264 147.987h44.683S343.378 18.501 453.012.003c0 0-134.473-2.707-242.748 147.984",
    style: {
      fill: "#c21540",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.14388
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m818.592 102.859-10.901 35.83h-26.252l10.901-35.83h-11.393l-12.024 39.522c-.849 2.789 1.238 5.605 4.153 5.605h36.878c3.822 0 7.194-2.5 8.307-6.155l11.857-38.972zM885.05 102.859h7.738c4.86 0 8.337 4.693 6.923 9.341l-10.888 35.786H877.89l9.596-31.543-18.968 25.302h-9.255l-4.511-25.302-9.596 31.543h-11.147l13.73-45.127h8.129a7.235 7.235 0 0 1 7.108 5.886l3.684 19.416zM759.781 112.157h-37.767l-2.656 8.733h37.332l-2.854 9.384h-37.333l-2.56 8.414h37.766l-2.829 9.299h-42.53c-3.304 0-5.67-3.193-4.708-6.353l9.613-31.594a10.128 10.128 0 0 1 9.69-7.181h41.665l-2.829 9.298",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.877967
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.221 36.17-34.018 111.814h-20.452l34.018-111.813ZM625.436 132.968h-58.999l2.742-9.009h58.997zm17.779-24.158H553.17l-11.917 39.175h99.527l9.158-30.1c1.375-4.514-2.004-9.075-6.723-9.075M549.352 86.81l-4.454 14.638h114.591l4.454-14.637zM473.272 73.68c-2.134 12.572-13.141 25.783-24.585 29.514-11.446 3.73-18.992-3.437-16.857-16.006 2.134-12.57 13.143-25.783 24.587-29.512 11.443-3.73 18.992 3.435 16.855 16.004m-13.177-34.642c-22.478 3.079-44.08 24.109-48.247 46.97-4.166 22.864 10.679 38.9 33.159 35.824 22.478-3.079 44.08-24.109 48.246-46.97 4.167-22.864-10.678-38.903-33.158-35.824M643.01 55.65c-1.01 5.315-14.08 9.731-29.194 9.861-15.116.133-26.55-4.07-25.54-9.386 1.01-5.317 14.081-9.733 29.195-9.861 15.115-.132 26.55 4.07 25.54 9.386m-23.212-23.527c-26.632 0-50.13 10.804-52.479 24.135-2.352 13.33 17.335 24.136 43.967 24.136 26.632 0 50.13-10.806 52.477-24.136 2.352-13.331-17.333-24.135-43.965-24.135",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.13222
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKtxEumLogo);
export default __webpack_public_path__ + "static/media/KTX_EUM_logo.b07acf1e25169f5104e5bfbd3d8e9444.svg";
export { ForwardRef as ReactComponent };